import React from 'react';
import HelmetComponent from '../../utils/HelmetHelper';
import { requireUserLogin, requireUserVerify } from '../../routes/Auth';
import requireUsernameChange from '../../routes/Auth/HOCs/requireUsernameChange';
import CreditPackages from './CreditPackages';
import LeftMenu from '../../components/LeftMenu';

const CreditsPage = (props) => {
  const {
    user,
    match: { path },
  } = props;

  return (
    <LeftMenu activeKey={path}>
      <HelmetComponent title={`${"Krediti"} | ${"INDEX OGLASI"}`} index={false} />

      <div className="page-title">{"Krediti"}</div>

      <CreditPackages
        {...props}
      />
    </LeftMenu>
  );
}

export default requireUserLogin(
  requireUsernameChange(
    requireUserVerify(
      CreditsPage
    )
  )
);


// WEBPACK FOOTER //
// ./src/containers/CreditsPage/index.tsx